<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
    :class="{ 'required': required }"
  >
    <b-select
      :value="value"
      :disabled="disabled"
      @input="inputListener"
    >
      <slot />
    </b-select>
  </b-field>
</template>

<script>

import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: false,
      default: "",
      validator (value) {
        return _.isNumber(value) || _.isString(value) || value === null || value === undefined || typeof value == "boolean";
      }
    },
    disabled: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
};
</script>
